<template>
  <pt-sign-notes-form ref="form" class="pt-sign-notes-form__withData" :fieldsArr="fieldsArr" v-loading="loading"
  :addressBusinessType="businessType" :isEdit="isEdit" :data="signContent" :noteDetail="noteDetail" :isSpecalActiveSign="isSpecalActiveSign" @dateSubmit="dateSubmit"
  :isAnniversarySign="isAnniversarySign"></pt-sign-notes-form>
</template>

<script>
import PtSignNotesForm from './form'
export default {
  name: 'pt-sign-notes-form__withData',
  components: {
    'pt-sign-notes-form': PtSignNotesForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    fieldsArr () {
      return this.signContent.form && this.signContent.form.fields
    },
    // 过滤省市区接口所需type(存储报名表单对应的省市区接口会过滤掉一些省市区)
    businessType () {
      return this.type === 'STORAGE' ? 'STORAGE_FORM' : this.type
    },
    // 生命体验管预约报名（）
    isSpecalActiveSign () {
      return this.signContent.ruleActivityCode && this.signContent.ruleActivityCode === 'LIFE_EXPERIENCE_HALL'
    },
    isAnniversarySign () {
      return this.signContent.ruleActivityCode && this.signContent.ruleActivityCode === 'TWENTIETH_ANNIVERSARY_ACT'
    }
  },
  props: {
    isEdit: {
      type: Boolean
    },
    id: {
      type: String
    },
    noteId: {
      type: String
    }
  },
  data () {
    return {
      signContent: {},
      noteDetail: {},
      type: null,
      formValue: {},
      loading: false,
      visitTimeList: []
    }
  },
  methods: {
    dateSubmit (val, fieldKey) {
      let date = new Date(val)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let data = {
        year: year,
        month: month,
        day: day
      }
      this.$store.dispatch('getDateIsHoliday', data).then(res => {
        if (res) {
          this.$message.error('请选择工作日作为预约参观时间')
          this.$refs.form.emptyDate(fieldKey)
        } else {
          this.formValue[fieldKey] = val
        }
      }).catch(err => {
        this.$message.error(err || '查询节假日失败')
      })
      this.formValue[fieldKey] = val
    },
    submit () {
      let i = 0
      this.form.basicItem.forEach((item, index) => {
        item.validate().then(res => {
          let formValue = this.form.formValue
          i = i + 1
          if (this.signContent.form && this.signContent.form.fields && this.signContent.form.fields.length && (i === this.signContent.form.fields.length)) {
            this.form.validate().then(res => {
              let data = {
                genericFormData: {
                  data: {
                    ...formValue, ...this.formValue
                  }
                } }
              data.mallRegistrationEventId = this.id
              data.id = this.noteId
              if (this.isAnniversarySign) {
                // 处理储存地区的特殊情况
                let address = data.genericFormData.data.address
                data.genericFormData.data.address = [
                  { value: address.provinceGbCode, text: address.provinceName },
                  { value: address.cityGbCode, text: address.cityName },
                  { value: address.districtGbCode, text: address.districtName }
                ]
              }
              this.$emit('submiting', true)
              this.$store.dispatch('editUserRegistrations', data).then(res => {
                // doing something ...
                this.$emit('submiting', false)
                this.$message.success('编辑报名成功')
                let vm = this
                setTimeout(function () {
                  vm.$router.push('/save-sign/active-sign-notes/' + vm.signContent.name + '/' + vm.signContent.id)
                }, 300)
              }).catch(errorMessage => {
                this.$message.error(errorMessage || '编辑报名记录失败')
              })
            })
          }
        })
      })
      this.form.validate().then(formValue => {
      })
    },
    load () {
      let data = {
        eventId: this.id,
        recordId: this.noteId
      }
      this.loading = true
      this.$store.dispatch('getRegisterNoteDetail', data).then(res => {
        this.signContent = res.mallRegistrationEventDTO
        this.noteDetail = res.mallUserRegistrationDTO
        if (this.noteDetail.activityCode === 'TWENTIETH_ANNIVERSARY_ACT') {
          // 处理周年活动中的储存地区
          let address = this.noteDetail.genericFormData.data.address
          this.noteDetail.genericFormData.data.address = {
            provinceGbCode: address[0].value,
            provinceName: address[0].text,
            cityGbCode: address[1].value,
            cityName: address[1].text,
            districtGbCode: address[2].value,
            districtName: address[2].text
          }
        }
        this.type = this.signContent.type
        this.loading = false
        if (this.signContent.ruleActivityCode === 'LIFE_EXPERIENCE_HALL') {
          this.getLifeExperienceHalls()
        }
        if (this.signContent.ruleActivityCode === 'TWENTIETH_ANNIVERSARY_ACT') {
          // this.getLifeExperienceHallsTime()
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取记录详情失败')
      })
    },
    // 体验馆列表
    getLifeExperienceHalls () {
      let data = {
        pageable: {
          page: 0,
          pageSize: 9999
        }
      }
      this.$store.dispatch('getLifeExperienceHallsList', data).then(res => {
        let fields = this.signContent && this.signContent.form && this.signContent.form.fields
        if (fields && fields.length) {
          fields.forEach(item => {
            if (item.optionsEnum === 'lifeExperienceHall') {
              item.options = []
              if (res.data && res.data.length) {
                res.data.forEach(etem => {
                  item.options.push({
                    label: etem.name,
                    value: etem.id
                  })
                })
              }
            }
          })
        }
      }).catch(err => {
        this.$message.error(err || '获取生命体验馆失败')
      })
    },
    getLifeExperienceHallsTime () {
      this.$store.dispatch('getLifeExperienceHallsTime', 'TWENTIETH_ANNIVERSARY_ACT').then(res => {
        this.visitTimeList = res
        let fields = this.signContent && this.signContent.form && this.signContent.form.fields
        if (fields && fields.length) {
          fields.forEach(item => {
            if (item.optionsEnum === 'lifeExperienceHallVisit') {
              item.options = []
              if (res && res.length) {
                res.forEach(etem => {
                  item.options.push({
                    label: etem.lifeExperienceHallDTO.name,
                    value: etem.lifeExperienceHallDTO.id
                  })
                })
              }
            }
          })
        }
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
